import React, { useState } from 'react';
import styles from './ReviewSlider.module.scss';
import { SVGIcon } from '../SVGIcon/SVGIcon';
import ReviewsArray from './reviews.json';

type ReviewData = {
  quote: string;
  cite: {
    author: string;
    location: string;
  }
}

export const ReviewsSlider = (): React.JSX.Element => {
  const reviews = ReviewsArray as ReviewData[];
  const length = reviews.length + 2;
  const precent = 100 / length;
  const [index, setIndex] = useState(-1);
  const [suppessAnim, setSuppessAnim] = useState(false);

   const onNext = () => {
    if (index === -(length - 2)) {
      setSuppessAnim(true);
      setIndex(0);
      setTimeout(() => {
        setSuppessAnim(false);
        setIndex(-1);
      }, 20)
    } else {
      setIndex(index - 1);
    }
    
   }

  const onPrevious = () => {
    if (index + 1 === 0) {
      setSuppessAnim(true);
      setIndex(-(length - 1));
      setTimeout(() => {
        setSuppessAnim(false);
        setIndex(-(length - 2));
      }, 20);
    } else {
      setIndex(index + 1);
    }
  }

  return (
    <div className={styles.slider}>
      <h3 className='headline__h1 color--ocean-blue'>
        Customer Reviews
      </h3>

      <div className={styles.slidesWrap}>
        <div 
          className={styles.slides} 
          style={{ 
            width: `${reviews.length + 2}00%`,
            transform: `translateX(${index * precent}%)`
          }}
          data-suppress={suppessAnim}
        >
          <div className={styles.slide}>
            <p className={styles.quote}>
              “{ reviews[reviews.length - 1].quote }”
            </p>

            <cite>
              <span>
                { reviews[reviews.length - 1].cite.author }
              </span>

              <span className='subtitle'>
                { reviews[reviews.length - 1].cite.location }
              </span>
            </cite>
          </div>
          {
            reviews.map((rev, i) => (
              <div key={`review-${i}`} className={styles.slide}>
                <p className={styles.quote}>
                  “{ rev.quote }”
                </p>

                <cite>
                  <span>
                    { rev.cite.author }
                  </span>

                  <span className='subtitle'>
                    { rev.cite.location }
                  </span>
                </cite>
              </div>
            ))
          }
          <div className={styles.slide}>
            <p className={styles.quote}>
              “{ reviews[0].quote }”
            </p>

            <cite>
              <span>
                { reviews[0].cite.author }
              </span>

              <span className='subtitle'>
                { reviews[0].cite.location }
              </span>
            </cite>
          </div>
        </div>
      </div>

      <div className={styles.nav}>
        <button
          title='previous review'
          aria-label='previous review'
          onClick={onPrevious}
        >
          <SVGIcon 
            id='chevron' 
            color='ocean-blue' 
            rotate={180}
          />
        </button>

        <button 
          title='next review'
          aria-label='next review'
          onClick={onNext}
        >
          <SVGIcon 
            id='chevron' 
            color='ocean-blue'
          />
        </button>
      </div>
    </div>
  )

}